import React from 'react'
import { FormTextField } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'

export default function FirstNameField() {
  const [t] = useTranslation()
  return (
    <FormTextField
      name="firstName"
      label={`${t('conference-announce.subscribe.first-name.field', 'First Name')}: *`}
      required
    />
  )
}
